export default __webpack_public_path__ + "static/media/logo.899f7ae4.svg";